import { storeStructure } from '../store/reducers';
import formGroupVoDTemplateGeneralSettings from './formGroupVoDTemplateGeneralSettings';
import formGroupVoDTemplateOutput from './formGroupVoDTemplateOutput';
import formGroupVoDEncodingSettings from './formGroupVoDEncodingSettings';
import routes from '../routes/route';

export default {
  title: 'VoD Template Edit',
  attributeName: storeStructure.VoD,
  createURL: 'vod',
  sessionParams: [],
  getURL: 'vod',
  updateURL: 'vod',
  idAttribute: 'id',
  saveIdSessionNameAs: 'vodId',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  idUpdate:true,
  redirectUrl: routes.VOD_TEMPLATE.path,
  websocketChannel: 'vodDetails-vodId',
  websocketSessionParams: ['vodId'],
  websocketItem: 'vodDetails',
  formConfig: [
    formGroupVoDTemplateGeneralSettings,
    formGroupVoDTemplateOutput,
    formGroupVoDEncodingSettings
  ],
};
